import { render, staticRenderFns } from "./MarketplaceIcon.vue?vue&type=template&id=7c726cef"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c726cef')) {
      api.createRecord('7c726cef', component.options)
    } else {
      api.reload('7c726cef', component.options)
    }
    module.hot.accept("./MarketplaceIcon.vue?vue&type=template&id=7c726cef", function () {
      api.rerender('7c726cef', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/MarketplaceIcon.vue"
export default component.exports